module.exports = __webpack_public_path__ + "img/keyboard-fill.5a97b4cb.svg";